import * as React from 'react';
import { JSSClassesProps } from 'react-jss';
import { HotelLocation } from './HotelLocation';
import { HotelPopularity } from './HotelPopularity';
import AggregateRating from 'sletat-ui-components2/dist/components/AggregateRating';

import { ComponentJSSClasses } from './styles';

export interface HotelSubtitleProps {
  countryName: string | null;
  resortName: string | null;
  todayViewsCount: number | null;
  rating: number | null;
  reviewAmount: number;
  popularityLevel: number | null;
}

export interface StyledHotelSubtitleProps
  extends JSSClassesProps<ComponentJSSClasses>,
    HotelSubtitleProps {
}

export function HotelSubtitle(props: StyledHotelSubtitleProps) {
  const {
    classes,
    rating,
    popularityLevel,
    countryName,
    resortName,
    todayViewsCount,
    reviewAmount
  } = props;

  return (
    <div className={classes.container}>
      <div className={classes.row}>
        <div className={classes.item}>
          <HotelLocation
            countryName={countryName}
            resortName={resortName}
          />
        </div>
        {!!popularityLevel && (
          <div className={classes.item}>
            <HotelPopularity popularityLevel={popularityLevel} />
          </div>
        )}
      </div>
      <div className={classes.row}>
        {!!rating && (
          <div className={classes.item}>
            <AggregateRating
              className={classes.ratingBg}
              rating={rating}
              feedbacksAmount={reviewAmount}
              target="_self"
              feedbacksLink="#hotel-review-list"
            />
          </div>
        )}
        {todayViewsCount && (
          <div className={classes.item}>
            Просмотров сегодня: {todayViewsCount}
          </div>
        )}
      </div>
    </div>
  );
}
